(function () {
    'use strict';

    angular
        .module('memories')
        .directive('xxMemoryView', xxMemoryView);

    var rImageContentType = /^image\/.*/,
        rVideoContentType = /^video\/.*/,
        defaultProfilePicture = 'images/app/no-photo.png';

    // * Directive
    function xxMemoryView() {
        return {
            require: ['xxMemoryView', '^^xxMemoryList'],
            restrict: 'E',
            templateUrl: 'app/memories/memory-view.html',
            controller: MemoryViewCtrl,
            scope: { memory: '=' },
            bindToController: true,
            controllerAs: 'vm',
            link: link
        };

        function link(scope, iElement, iAttrs, ctrls) {
            var xxMemoryView = ctrls[0], xxMemoryList = ctrls[1];
            xxMemoryView.init(xxMemoryList);
        }
    }

    // * Controller
    MemoryViewCtrl.$inject = ['$q', 'Memory', app.modules.common.services.storage];
    function MemoryViewCtrl($q, Memory, ggStorage) {
        var vm = this,
            memoryListCtrl,
            userId = +ggStorage.get(ggStorage.keys.member.id);

        vm.init = init;
        vm.getState = getState;
        vm.mediaLoadError = mediaLoadError;
        vm.editMemory = editMemory;
        vm.deleteMemory = deleteMemory;
        vm.getProfilePicture = getProfilePicture;
        vm.profilePictureError = profilePictureError;
        vm.canEdit = canEdit;

        function init(xxMemoryList) {
            memoryListCtrl = xxMemoryList;
        }

        function getState() {
            var contentType = vm.memory.$mediaContentType;
            return rImageContentType.test(contentType) ? 'image' :
                rVideoContentType.test(contentType) ? 'video' :
                contentType === 'notfound' ? 'notfound' :
                null;
        }

        function mediaLoadError() {
            vm.memory.$mediaContentType = 'notfound';
        }

        function editMemory() {
            vm.memory.$editing = true;
            memoryListCtrl.notifyEdit(vm.memory);
        }

        function deleteMemory() {
            var memory = vm.memory;

            $q.when()
                .then(confirmDelete)
                .then(deleteMemory)
                .then(notifyParentCtrl)
                .catch(handleError);

            function confirmDelete() {
                return window.confirm('Are you sure you want to delete this memory!') || $q.reject();
            }

            function deleteMemory() {
                return Memory.delete(null, { id: memory.id }).$promise;
            }

            function notifyParentCtrl() {
                memoryListCtrl.notifyDeleted(memory);
            }
            function handleError(error) {
                error && alert(error instanceof Error ? error.message : 'Failed to delete memory!');
                return $q.reject(error);
            }
        }

        function getProfilePicture() {
            return vm.memory.$createdByPhoto || defaultProfilePicture
        }

        function profilePictureError() {
            vm.memory.$createdByPhoto = null;
        }

        function canEdit() {
            return memoryListCtrl.isAdministrator || userId === vm.memory.createdById;
        }
    }
})();